module.exports = __webpack_public_path__ + "static/media/Line_21.aa61c90a.svg";